import {
  ExtraWorkedTimeRequestPayer,
  ExtraWorkedTimeRequestStatus,
  ExtraWorkedTimeRequestStatusUpdater,
  ExtraWorkedTimeType,
} from "@src/appV2/ExtraWorkedTimeRequests/types";
import { z } from "zod";

// eslint-disable-next-line no-restricted-syntax
export enum TimesheetType {
  PHOTO = "photo",
  CDPH530 = "CDPH-530",
}

// eslint-disable-next-line no-restricted-syntax
export enum InstantPayUser {
  HCF = "HCF",
  HCP = "HCP",
}

export const timeCardFilesTypeSchema = z.object({
  url: z.string().optional(),
  filename: z.string(),
  fileStorageFileKey: z.string().optional(),
  pdfFileStorageFileKey: z.string().optional(),
  fileStorageRootFolder: z.string().optional(),
  s3Url: z.string().optional(),
  signedType: z.string().nullish(),
  timesheet: z.string().nullish(),
  digitallySignedBy: z.string().optional(),
  uploadedBy: z.string().nullish(),
});

export type TimeCardFilesType = z.infer<typeof timeCardFilesTypeSchema>;

export const timecardSchema = z.object({
  files: z.union([z.array(timeCardFilesTypeSchema), z.array(z.never())]),
  digitallySignedBy: z.string().nullish(),
  createdAt: z.string().optional(),
  digitallySignedByHCP: z.string().nullish(),
  verifiedBy: z.string().nullish(),
  status: z.string().nullish(),
});

export type TimeCardType = z.infer<typeof timecardSchema>;

export const signatorySchema = z.object({
  _id: z.string().nullish(),
  signatoryId: z.string().nullish(),
  signedAt: z.string().nullish(),
  method: z.string().nullish(),
});

export const lunchInOutSchema = z.object({
  end: z.string().nullish(),
  isSkipped: z.boolean().nullish(),
  lunchInBy: z.string().nullish(),
  lunchInCreatedAt: z.string().nullish(),
  lunchOutBy: z.string().nullish(),
  lunchOutCreatedAt: z.string().nullish(),
  start: z.string().nullish(),
});

export type LunchInOut = z.infer<typeof lunchInOutSchema>;

// eslint-disable-next-line no-restricted-syntax
export enum TableType {
  SHIFTS = "SHIFTS",
  SENT_HOME_FEES = "SENT_HOME_FEES",
  LATE_CANCELATION_FEES = "LATE_CANCELATION_FEES",
  OTHER_CHARGES = "OTHER_CHARGES",
}

export interface PermissionSet {
  canVerifyShifts: boolean;
  canViewChargeRate: boolean;
  canDisputeCharge: boolean;
}

export const extraWorkedTimeTypeSchema = z.nativeEnum(ExtraWorkedTimeType);

export const extraWorkedTimeRequestStatusSchema = z.nativeEnum(ExtraWorkedTimeRequestStatus);

export const extraWorkedTimeRequestPayerSchema = z.nativeEnum(ExtraWorkedTimeRequestPayer);

export const extraWorkedTimeRequestStatusUpdaterSchema = z.nativeEnum(
  ExtraWorkedTimeRequestStatusUpdater
);

export const extraWorkedTimeRequestSchema = z.object({
  _id: z.string(),
  type: extraWorkedTimeTypeSchema,
  reason: z.string(),
  authorizingEmployee: z
    .object({
      name: z.string(),
      jobTitle: z.string(),
    })
    .optional(),
  start: z.string(),
  end: z.string(),
  status: extraWorkedTimeRequestStatusSchema,
  createdAt: z.string(),
  billedTo: extraWorkedTimeRequestPayerSchema.optional(),
  statusUpdatedBy: extraWorkedTimeRequestStatusUpdaterSchema.nullish(),
  statusUpdatedById: z.string().optional(),
  statusUpdateReason: z.string().optional(),
  updatedAt: z.string().optional(),
});
